import React from 'react'
import { mount } from 'enzyme'

import { DefaultTextArea } from '../../elements'

describe("DefaultTextArea",() => {
  let props, wrapper, instance, result

  beforeEach(() => {
    props = {
      value : 'hello',
      onKeyPress: () => {
        result = 'onKeyPress'
      },
      onBlur: () => {
        result = 'onBlur'
      }
    }
    wrapper = mount(<DefaultTextArea {...props}/>)
    instance = wrapper.instance()
  })

  describe('#valueCount', () => {
    it('returns number', () => {
      const { valueCount } = instance

      expect(valueCount).toBe(5)
    })
  })

  describe('#onKeyPress', () => {
    it('runs function', () => {
      instance.onKeyPress({ which: 13, preventDefault: () => true, target: { blur: () => true } })

      expect(result).toBe('onKeyPress')
    })
  })

  describe('#onChangeInputText', () => {
    it('sets value', () => {
      instance.onChangeInputText({ target: { value: 'value' } })

      expect(instance.state.value).toBe('value')
    })
  })

  describe('#onValidateInput', () => {
    it('runs function', () => {
      instance.onValidateInput({ target: { value: 'value' } })

      expect(result).toBe('onBlur')
    })
  })

  describe('#renderCountTruncate', () => {
    it('runs function', () => {
      expect(instance.renderCountTruncate()).toBeTruthy()
    })
  })
})
